import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    fetchMyPayments,
    selectMyPayments,
} from '../features/billing/billing.slice';
import { selectLoggedInUser } from '../features/auth/auth.slice';

const useMyPayments = () => {
    const dispatch = useAppDispatch();
    const payments = useAppSelector(selectMyPayments);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);

    const getMyPayments = async () => {
        if (loggedInUserDetails?.roleData.businessUser?.id) {
            await dispatch(
                fetchMyPayments(loggedInUserDetails.roleData.businessUser?.id),
            );
        }
    };

    useEffect(() => {
        if (payments.length === 0) {
            getMyPayments();
        }
    }, []);

    return [payments];
};

export default useMyPayments;
